import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/www/components/_page-components/industries/benefits/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/www/components/_page-components/industries/hero/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/_page-components/industries/logos/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/_page-components/industries/quote/marks.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/_page-components/industries/quote/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/_page-components/industries/resources/arrow.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/_page-components/industries/solutions/arrow.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/_page-components/industries/uses-cases/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/_page-components/industries/solutions/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/_page-components/industries/text-split/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/_page-components/industries/resources/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/call-to-action/styles/variant-centered.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/call-to-action/styles/variant-compact.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/call-to-action/styles/variant-compact-grid.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/call-to-action/styles/variant-links.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/components/_page-components/industries/call-to-action/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/legacy/image.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionContent","AccordionItem","AccordionToggle"] */ "/vercel/path0/packages/mds-react/dist/components/accordion/item/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Item"] */ "/vercel/path0/packages/mds-react/dist/components/breadcrumbs/item/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["TruncationButton"] */ "/vercel/path0/packages/mds-react/dist/components/breadcrumbs/truncation-button/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Card","CardContent"] */ "/vercel/path0/packages/mds-react/dist/components/card/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlock"] */ "/vercel/path0/packages/mds-react/dist/components/code-block/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ComboBox","Root","Trigger","Value","Popover","SearchInput","List","Item"] */ "/vercel/path0/packages/mds-react/dist/components/combo-box-primitive/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["DisclosurePrimitive"] */ "/vercel/path0/packages/mds-react/dist/components/disclosure-primitive/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["useDisclosurePrimitive"] */ "/vercel/path0/packages/mds-react/dist/components/disclosure-primitive/use-disclosure-primitive.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToggleButton"] */ "/vercel/path0/packages/mds-react/dist/components/dropdown/toggle-button/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/mds-react/dist/components/flight-icon/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["CheckboxBase","CheckboxField","CheckboxGroup"] */ "/vercel/path0/packages/mds-react/dist/components/form/checkbox/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/vercel/path0/packages/mds-react/dist/components/hds/wrappers/tooltip.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/mds-react/dist/components/interactive/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/mds-react/dist/components/menu-primitive/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/vercel/path0/packages/mds-react/dist/components/modal/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["useModal"] */ "/vercel/path0/packages/mds-react/dist/components/modal/use-modal.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "/vercel/path0/packages/mds-react/dist/components/tabs/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["useTabsContext"] */ "/vercel/path0/packages/mds-react/dist/components/tabs/use-tabs-context.js");
;
import(/* webpackMode: "eager", webpackExports: ["BarChart"] */ "/vercel/path0/packages/mds-react/dist/components/visualizations/bar-chart/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["DonutChart"] */ "/vercel/path0/packages/mds-react/dist/components/visualizations/donut-chart/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleContext"] */ "/vercel/path0/packages/mds-react/dist/utils/i18n/helpers/locale-provider.js");
